import type {Vehicle} from "../types";

/**
 * Residency truthiness for enforcement display.
 *
 * Residency is backend-managed (established only via permanent-parking permit
 * issuance) and projected onto `resident_id`, the authoritative fast cache the
 * FE should read. The `resident` embed is only a convenience for name/household
 * labels and may not always be populated, so it must NOT drive the
 * Resident vs Unknown decision.
 */
export function isResidentVehicle(
  vehicle: Pick<Vehicle, "resident_id"> | null | undefined,
): boolean {
  return vehicle?.resident_id != null;
}
